<template>
  <div>
    <form id="delete" @submit.prevent="showModal = true">
        <input type="submit" class="submit" v-bind:value="$t('admin.adminProjectDelete.button.delete')">
    </form>
    <Modal class="alert" v-if="showModal" v-bind:modalTitle="$t('admin.adminProjectDelete.modal.header', {name: project.name})" @close="showModal = false">
      <p class="modal-text" v-html="$t('admin.adminProjectDelete.modal.text')"></p>
      <a v-on:click.prevent="deleteProject" class="button" href="#">{{ $t("admin.adminProjectDelete.modal.button") }}</a>
    </Modal>
  </div>
</template>

<script>
import Modal from '@/components/Modal.vue'

import { adminService } from '@/services/admin.service'

export default {
  props: ['project'],
  name: 'AdminProjectDelete',
  components: {
    Modal
  },
  data: function () {
    return {
      showModal: false
    }
  },
  methods: {
    deleteProject: function () {
      adminService.projectDelete(this.project.id).then(() => {
        console.log('delete project: ' + this.project.name)
        this.showModal = false
        this.$router.push('/admin/groupView/' + this.project.groupId)
      }).catch((err) => {
        console.error('Unable to delete project: ', err)
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.modal-text {
  font-weight: bold;
}
</style>
